module.exports = __webpack_public_path__ + "static/media/piper-tool.a927e096.svg";